import { useCallback } from "react"
import { Block, LabelLarge, Plus, useStyletron } from "@mezo-org/mezo-clay"
import { Link } from "@tanstack/react-router"

import { routes } from "#/shared/constants"

type DepositButtonProps = {
  onClick: () => void
}

export default function DepositButton({ onClick }: DepositButtonProps) {
  const [css, theme] = useStyletron()

  const buttonClickHandler = useCallback(() => {
    onClick()

    // We need to scroll back to top since user can
    // have a lot of deposits and will view the
    // deposit form from the bottom
    window.scrollTo({ top: 0, left: 0 })
  }, [onClick])

  return (
    <Block
      as={Link}
      href={routes.DEPOSIT}
      onClick={buttonClickHandler}
      className={css({
        background: theme.colors.green50,
        borderColor: theme.colors.green200,
        borderWidth: "1px",
        borderRadius: theme.borders.radius400,
        padding: theme.sizing.scale800,
        width: "100%",
        minHeight: "244px",
        "@media screen and (min-width: 1136px)": {
          height: "100%",
        },
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      })}
    >
      <Plus color={theme.colors.green700} />
      <LabelLarge
        color={theme.colors.green700}
        marginLeft={theme.sizing.scale300}
      >
        New deposit
      </LabelLarge>
    </Block>
  )
}
